//CSSをバンドル
import 'Src/scss/schoolRental-detail.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'




import 'slick-carousel'

import $ from 'jquery'

$(function () {
  var _width = $(window).width()
  if (_width < 769) {
    $('label.nav-h').click(function () {
      document.getElementById('subNavSlide').checked = false
      document.getElementById('nav-school').checked = false
      document.getElementById('nav-lesson').checked = false
    })
    $('a.clickBtn').click(function () {
      document.getElementById('nav01').checked = false
    })
    $('label.subNav-h').click(function () {
      //サブナビ
      document.getElementById('subNavSlide').checked = true
    })
    $('label.subNav-close').click(function () {
      //サブナビ
      document.getElementById('subNavSlide').checked = false
    })
    $('label.nav-bg').click(function () {
      //サブナビ
      document.getElementById('subNavSlide').checked = false
      document.getElementById('nav-school').checked = false
      document.getElementById('nav-lesson').checked = false
    })
  }
})

//////////  scroll  //////////

//$(function(){
//    var headerHight = 30; //ヘッダの高さ
//	$('a[href^="#"]').click(function(){
//		var speed = 500;
//		var href= $(this).attr("href");
//		var target = $(href == "#" || href == "" ? 'html' : href);
//		var position = target.offset().top - headerHight;
// 		$("html, body").animate({scrollTop:position}, speed, "swing");
//		return false;
//	});
//});

$(document).ready(function () {
  //URLのハッシュ値を取得
  var urlHash = location.hash
  //ハッシュ値があればページ内スクロール
  if (urlHash) {
    //スクロールを0に戻す
    $('body,html').stop().scrollTop(0)
    setTimeout(function () {
      //ロード時の処理を待ち、時間差でスクロール実行
      scrollToAnker(urlHash)
    }, 100)
  }

  //通常のクリック時
  $('a[href^="#"]').click(function () {
    //ページ内リンク先を取得
    var href = $(this).attr('href')
    //リンク先が#か空だったらhtmlに
    var hash = href == '#' || href == '' ? 'html' : href
    //スクロール実行
    scrollToAnker(hash)
    //リンク無効化
    return false
  })

  // 関数：スムーススクロール
  // 指定したアンカー(#ID)へアニメーションでスクロール
  function scrollToAnker(hash) {
    var target = $(hash)
    var position = target.offset().top - 50
    $('body,html').stop().animate({ scrollTop: position }, 500)
  }
})

//////// iOS10 ピンチインピンチアウト対策 //////////

document.addEventListener(
  'touchstart',
  function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  },
  true
)

let lastTouch = 0
document.addEventListener(
  'touchend',
  function (event) {
    const now = window.performance.now()
    if (now - lastTouch <= 500) {
      event.preventDefault()
    }
    lastTouch = now
  },
  true
)

//////////  電話番号Android対応 //////////
$(function () {
  var ua = navigator.userAgent
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
    $('.tel_link').each(function () {
      var str = $(this).text()
      $(this).html(
        $('<a>')
          .attr('href', 'tel:' + str.replace(/-/g, ''))
          .append(str + '</a>')
      )
    })
  }
})

////////// 画像名置き換える  //////////

$(function () {
  var $setElem = $('.switch'),
    pcName = 'PC',
    spName = 'MOB',
    replaceWidth = 768

  $setElem.each(function () {
    var $this = $(this)
    function imgSize() {
      if (window.innerWidth > replaceWidth) {
        $this.attr('src', $this.attr('src').replace(spName, pcName)).css({ visibility: 'visible' })
      } else {
        $this.attr('src', $this.attr('src').replace(pcName, spName)).css({ visibility: 'visible' })
      }
    }
    $(window).resize(function () {
      imgSize()
    })
    imgSize()
  })

  $('.onImg').each(function () {
    var src_off = $(this).find('img').attr('src')
    var src_on = src_off.replace('-off', '-on')
    $('<img />').attr('src', src_on)
    $(this).hover(
      function () {
        $(this).find('img').attr('src', src_on)
      },
      function () {
        $(this).find('img').attr('src', src_off)
      }
    )
  })
})

////////// トップへ戻る  //////////

$(function () {
  $(window).scroll(function () {
    //スクロールしたら処理を開始する

    var pagetop = $('.pagetop')
    var scroll = $(window).scrollTop() + $(window).height() //ページトップから現在の画面下部までの高さ
    var footer = $('footer').offset().top //ページトップからfooterまでの高さ
    var absoluteBottom = $('footer').outerHeight() + 10 //footerの高さ(margin、padding、borderの値を含める)
    if ($(window).scrollTop() > $(window).height()) {
      //ページトップから1画面の高さ分、下にスクロールしたら
      pagetop.fadeIn() //「ページトップへ戻る」ボタンをフェードインさせる
    } else {
      pagetop.fadeOut() //ページトップから1画面の高さ以内でスクロールしている場合はフェードアウト
    }
    if (scroll > footer) {
      //画面下部からfooterが現れたら
      pagetop.css({
        position: 'absolute', //固定表示を解除する
        width: '50px',
        height: '50px',
        right: '10px',
        bottom: absoluteBottom, //bottomはfooterの高さ分あける
      })
    } else {
      pagetop.css({
        //画面下部にfooterが現れるまでは
        position: 'fixed', //固定表示する
        width: '50px',
        height: '50px',
        right: '10px',
        bottom: '10px',
      })
    }
  })
})

////////// アコーディオン開閉  //////////

$(function () {
  $('.acMenu dt').on('click', function () {
    if ($(this).next().css('opacity') == '0') {
      $(this).next().slideToggle()
      $(this).next().css('opacity', 0).animate({ opacity: '1' }, { duration: '100', easing: 'swing' })
    }
    if ($(this).next().css('opacity') == '1') {
      $(this).next().css('opacity', 1).animate({ opacity: '0' }, { duration: '10', easing: 'swing' })
      $(this).next().slideToggle()
    }
    //        return false;
    //      if($(this).next().css("display")=="none"){
    //          $(this).next().fadeIn(1500);
    //      }
  })
})

$(function () {
  $('.slider-topics').slick({
    autoplay: true,
    infinite: true,
    speed: 800,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })
  $('.slider-event').slick({
    autoplay: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })
})

$(document).ready(function () {
  $('.slider').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    speed: 1600,
    arrows: false,
    cssEase: 'ease-in-out',
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    touchMove: false,
  })
})

var scrollAnimationElm = document.querySelectorAll('.sa')
var scrollAnimationFunc = function () {
  for (var i = 0; i < scrollAnimationElm.length; i++) {
    var triggerMargin = 100
    if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
      scrollAnimationElm[i].classList.add('show')
    }
  }
}
window.addEventListener('load', scrollAnimationFunc)
window.addEventListener('scroll', scrollAnimationFunc)

$(function () {
  //グローバル変数
  var nowModalSyncer = null //現在開かれているモーダルコンテンツ
  var modalClassSyncer = 'modal-syncer' //モーダルを開くリンクに付けるクラス名

  //モーダルのリンクを取得する
  var modals = document.getElementsByClassName(modalClassSyncer)

  //モーダルウィンドウを出現させるクリックイベント
  for (var i = 0, l = modals.length; l > i; i++) {
    //全てのリンクにタッチイベントを設定する
    modals[i].onclick = function () {
      //ボタンからフォーカスを外す
      this.blur()

      //ターゲットとなるコンテンツを確認
      var target = this.getAttribute('data-target')

      //ターゲットが存在しなければ終了
      if (typeof target == 'undefined' || !target || target == null) {
        return false
      }

      //コンテンツとなる要素を取得
      nowModalSyncer = document.getElementById(target)

      //ターゲットが存在しなければ終了
      if (nowModalSyncer == null) {
        return false
      }

      //キーボード操作などにより、オーバーレイが多重起動するのを防止する
      if ($('#modal-overlay')[0]) return false //新しくモーダルウィンドウを起動しない
      //if($("#modal-overlay")[0]) $("#modal-overlay").remove() ;		//現在のモーダルウィンドウを削除して新しく起動する

      //オーバーレイを出現させる
      $('body').append('<div id="modal-overlay"></div>')
      $('#modal-overlay').fadeIn('fast')

      //コンテンツをセンタリングする
      centeringModalSyncer()

      //コンテンツをフェードインする
      $(nowModalSyncer).fadeIn('slow')

      //[#modal-overlay]、または[#modal-close]をクリックしたら…
      $('#modal-overlay,#modal-close')
        .unbind()
        .click(function () {
          //[#modal-content]と[#modal-overlay]をフェードアウトした後に…
          $('#' + target + ',#modal-overlay').fadeOut('fast', function () {
            //[#modal-overlay]を削除する
            $('#modal-overlay').remove()
          })

          //現在のコンテンツ情報を削除
          nowModalSyncer = null
        })
    }
  }

  //リサイズされたら、センタリングをする関数[centeringModalSyncer()]を実行する
  $(window).resize(centeringModalSyncer)

  //センタリングを実行する関数
  function centeringModalSyncer() {
    //モーダルウィンドウが開いてなければ終了
    if (nowModalSyncer == null) return false

    //画面(ウィンドウ)の幅、高さを取得
    // var w = $(window).width() //未使用なのでコメントアウトした 2022/02/03 19:54
    var h = $(window).height()

    //コンテンツ(#modal-content)の幅、高さを取得
    // jQueryのバージョンによっては、引数[{margin:true}]を指定した時、不具合を起こします。
    //		var cw = $( nowModalSyncer ).outerWidth( {margin:true} ) ;
    //		var ch = $( nowModalSyncer ).outerHeight( {margin:true} ) ;
    // var cw = $(nowModalSyncer).outerWidth() //未使用なのでコメントアウトした 2022/02/03 19:54
    var ch = $(nowModalSyncer).outerHeight()

    //センタリングを実行する
    $(nowModalSyncer).css({ top: 'calc(45px + ' + (h - ch) / 2 + 'px)' })
  }
})
